module.exports = __webpack_public_path__ + "img/fair_catch_right.d8d14218.jpg";